import { registerLocaleData } from '@angular/common';
import * as de from '@angular/common/locales/de';
import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ToastModule } from 'primeng/toast';
import { APP_VERSION } from '../version';
import { TopbarComponent } from './topbar/topbar';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, TopbarComponent, ToastModule, ConfirmDialogModule],
  templateUrl: './app.html',
  styleUrl: './app.css',
})
export class App {
  readonly version = APP_VERSION;

  constructor() {
    registerLocaleData(de.default);
  }
}
